import React from 'react';
import { formatCurrency } from '../../utils/formatters';
import '../../styles/Dashboard.css';

const ConciliacionBancaria = ({ conciliacion = {} }) => {
  const {
    total_sistema = 0,
    total_ventas = 0,
    total_banco = 0,
    diferencia = 0,
    ultima_actualizacion = null
  } = conciliacion;

  // Usar total_ventas si total_sistema no está disponible
  const totalSistema = total_sistema || total_ventas;

  const getEstadoClass = () => {
    if (diferencia === 0) return 'conciliado';
    if (Math.abs(diferencia) < 1000) return 'warning';
    return 'error';
  };

  const getEstadoIcon = () => {
    if (diferencia === 0) return '✓';
    if (Math.abs(diferencia) < 1000) return '⚠';
    return '✗';
  };

  return (
    <div className="dashboard-widget">
      <h3 className="widget-title">
        <span className="widget-icon">🏦</span>
        Conciliación Bancaria
      </h3>
      <div className="widget-body">
        <div className="conciliacion-container">
          <div className="conciliacion-row">
            <div className="conciliacion-item">
              <span className="conciliacion-label">Sistema Total:</span>
              <span className="conciliacion-value">{formatCurrency(totalSistema)}</span>
            </div>
            <div className="conciliacion-item">
              <span className="conciliacion-label">Total Banco:</span>
              <span className="conciliacion-value">{formatCurrency(total_banco)}</span>
            </div>
          </div>
          
          <div className={`conciliacion-diferencia ${getEstadoClass()}`}>
            <span className="diferencia-icon">{getEstadoIcon()}</span>
            <div className="diferencia-content">
              <span className="diferencia-label">Diferencia:</span>
              <span className="diferencia-value">{formatCurrency(Math.abs(diferencia))}</span>
            </div>
          </div>

          {ultima_actualizacion && (
            <div className="conciliacion-footer">
              <small className="text-muted">
                Última actualización: {new Date(ultima_actualizacion).toLocaleString('es-CL')}
              </small>
            </div>
          )}

          {diferencia !== 0 && (
            <div className="conciliacion-alert">
              <p className="alert-text">
                {Math.abs(diferencia) < 1000 
                  ? 'Diferencia menor detectada. Revisar transacciones recientes.'
                  : 'Diferencia significativa detectada. Se requiere revisión urgente.'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConciliacionBancaria;

// Made with Bob
